import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

searchBoxStyles.search = {
    iconProps: { 
        src: Search,
        css: css`
            position: absolute;
            box-sizing: border-box;
            top: 2px;
            right: 2px;
            width: 36px;
            height: 36px;
            padding: 8px;
            border-radius: 100%;
            pointer-events: none;
        `,
    },
}